// AI Integration for Business service page.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function AiIntegration() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.philosophy}
        eyebrow="Services · Integration"
        headline="AI embedded where work"
        italicWord="happens."
        lede="We connect AI to the systems your team already uses, so the value lands where decisions are made."
      />

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What this is</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Your existing systems, made smarter.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You do not need to replace your ERP, your CRM or your plant management system to get
              value from AI. You need AI connected to them in a way that is reliable, secure and useful.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We build the connectors, the pipelines and the interfaces that bring AI capability into
              the tools your operators already know. No retraining. No disruption to existing workflows.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              We map your systems before we touch them.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              We start by understanding exactly how your business systems work today. We identify the
              highest-value integration points and the data flows that will drive the best outcomes.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              From there we build targeted integrations, test under real operating conditions and hand
              over with full documentation. We stay available for the first 30 days post-deployment.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              You have data but are not using it.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You have plant systems, telematics, ERPs or CRMs generating data that no one is acting
              on. You want AI to surface insights and recommendations inside the tools your team
              already opens every day.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              You need integrations that are secure, auditable and compatible with your existing IT
              governance.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
